import { createContext, useContext } from 'react';

import { LoginSuccess } from 'entities';

import { SuccessData } from 'services/api';

export interface AuthContextProps {
  isLogged: boolean;
  isLoadingSurveys: boolean;

  logout(): Promise<SuccessData>;

  deleteSession(): void;

  finishLogin(data: LoginSuccess): void;

  data: LoginSuccess | null;

  updateUser(data: Partial<LoginSuccess['user']>): void;

  updateData(data: Partial<Omit<LoginSuccess, 'user'>>): void;
}

export const AuthContext = createContext<AuthContextProps>({} as AuthContextProps);

export function useAuth() {
  const context = useContext(AuthContext);

  if (!context.logout) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return context;
}
